import React from 'react';
import { WithSearch } from '@elastic/react-search-ui';
import { __ } from '@wordpress/i18n';
import JobCardList from './JobCardList';
import JobCardSkeleton from './JobCardSkeleton';
import { useDelayedLoading } from '../../hooks/useDelayedLoading';
import { JobResult } from '../types/job';

const SKELETON_COUNT = 6;

interface ResultsBodyProps {
  results: JobResult[];
  isLoading: boolean;
}

// Split out so the loading hook runs in a real component body (rules of hooks),
// and so its timers persist across WithSearch re-renders.
const ResultsBody: React.FC<ResultsBodyProps> = ({ results, isLoading }) => {
  const showSkeleton = useDelayedLoading(isLoading);

  if (showSkeleton) {
    return (
      <div className="job-card-list" aria-busy="true">
        <span className="screen-reader-text" role="status">{__('Loading jobs', 'wp-plugin-jobs')}…</span>
        {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
          <JobCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (!results || results.length === 0) {
    return <div className="loading-wrapper"><p>{__('No jobs found', 'wp-plugin-jobs')}.</p></div>;
  }

  return <JobCardList results={results} />;
};

export const ElasticResultsWrapper: React.FC = () => (
    <WithSearch mapContextToProps={({ results, isLoading }) => ({ results, isLoading })}>
      {({ results, isLoading }: { results: JobResult[]; isLoading: boolean }) => (
        <ResultsBody results={results} isLoading={isLoading} />
      )}
    </WithSearch>
);
